<template>
  <Chart
    type="bar"
    :options="trafficOptions"
    :data="mainTrafficData"
    class="h-[40vh]"
  />
</template>

<script>
// import moment from "moment";
import Chart from "primevue/chart";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "homePage",
  components: {
    Chart,
  },
  props: {
    skill: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      incomingStat: [],
      outgoingStat: [],
      periods: [],
      trafficInterval: null,
      mainTrafficData: {
        labels: [],
        datasets: [
          {
            label: this.$t("home.agent_summary.answered"),
            data: [],
            fill: false,
            backgroundColor: "#22c55e",
            stepped: "middle",
            tension: 0.2,
          },
          {
            label: this.$t("home.agent_summary.abandoned"),
            data: [],
            fill: false,
            backgroundColor: "#ef4444",
            stepped: "middle",
            borderDash: [5, 5],
            tension: 0.2,
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions([
      "GetMainTraffic",
      "SetMessageDialog",
      "GetAnsweredAbandonedStat",
    ]),
    async initSummary() {
      var resp = await this.GetAnsweredAbandonedStat({
        from: `${moment().format("YYYY-MM-DD")} 00:00:00`,
        to: `${moment().format("YYYY-MM-DD")} 23:59:59`,
        skill: this.skill,
      });

      if (resp.success) {
        this.mainTrafficData.labels = resp.periods.map(
          (period) => period.period
        );
        const answeredData = new Array(this.mainTrafficData.labels.length).fill(
          0
        );
        const abandonedData = new Array(
          this.mainTrafficData.labels.length
        ).fill(0);

        resp.periods.forEach((period) => {
          const [hour, minute] = period.period.split(":");
          const timeStr = `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
          const index = this.mainTrafficData.labels.indexOf(timeStr);
          if (index !== -1) {
            answeredData[index] = period.answered;
            abandonedData[index] = period.abandoned;
          }
        });

        this.mainTrafficData.datasets[0].data = answeredData;
        this.mainTrafficData.datasets[1].data = abandonedData;
      }

    },
    async SetTrafficStat() {
      try {
        var resp = await this.GetMainTraffic();
        if (!resp.success) {
          return;
        } else {
          let incomingStat = [],
            outgoingStat = [],
            periods = [];
          let callsStats = JSON.parse(JSON.stringify(resp.summary));
          for (let i = 0; i < 24; i++) {
            if (resp.summary.length == 0) {
              callsStats.push({ incoming: 0, outgoing: 0, period: i });
            }
          }

          if (this.currentLocal == "ar") {
            callsStats = callsStats.reverse((a, b) => {
              return a - b;
            });
          }
          for (const stat of callsStats) {
            periods.push(stat.period);
            incomingStat.push(stat.incoming);
            outgoingStat.push(stat.outgoing);
          }
          this.periods = periods;
          this.incomingStat = incomingStat;
          this.outgoingStat = outgoingStat;
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
  },
  computed: {
    ...mapGetters(["domain"]),
    currentDay() {
      return this.$t("home.main_summary.taffic_day_title", {
        day: this.$d(new Date(), "short", "ar-EG"),
      });
    },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    trafficData() {
      return {
        labels: this.periods,
        datasets: [
          {
            label: this.$t("home.agent_summary.incoming"),
            backgroundColor: "transparent",
            borderColor: "#015A64",
            pointBackgroundColor: "#fff",
            borderWidth: 2,
            data: this.incomingStat,
            fill: false,
          },
          {
            label: this.$t("home.agent_summary.outgoing"),
            backgroundColor: "transparent",
            borderColor: "#00E676",
            pointBackgroundColor: "#fff",
            borderWidth: 2,
            data: this.outgoingStat,
            fill: false,
          },
        ],
      };
    },
    trafficOptions() {
      return {
        maintainAspectRatio: false,
        animation: false,
        categoryPercentage: 1,
        barPercentage: 0.8,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
          tooltip: {
            titleFont: {
              family: "IBMPlexSansArabic",
            },
            bodyFont: {
              family: "IBMPlexSansArabic",
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              color: "transparent",
              drawOnChartArea: true,
            },
            border: {
              dash: [2, 4],
            },
            ticks: {
              color: "black",
              font: {
                family: "IBMPlexSansArabic",
                size: 10,
              },
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0,
              // 👇 Format tick labels (e.g., "08" → "08h")
              callback: function (value) {
                // if (value % 2 !== 0) {
                //   return "";
                // }
                const labelVal = this.getLabelForValue(value).split(":")[0];
                return labelVal < 12
                  ? this.getLabelForValue(value) + " AM"
                  : this.getLabelForValue(value) + " PM";
              },
            },
          },
          y: {
            display: false,
            beginAtZero: true,
            stacked: true,
            grid: {
              color: "transparent",
              drawOnChartArea: true,
            },
            border: {
              dash: [2, 4],
            },
            ticks: {
              color: "black",
              font: {
                family: "IBMPlexSansArabic",
              },
              stepSize: 20,
            },
          },
        },
        // elements: {
        //   point: {
        //     radius: 5,
        //     hitRadius: 10,
        //     hoverRadius: 4,
        //     hoverBorderWidth: 3,
        //   },
        // },
      };
    },
  },
  watch: {
    async domain(newValue) {
      if (newValue) {
        await this.initSummary();
      }
    },
    async skill() {
      if (this.domain) {
        await this.initSummary();
      }
    },
  },
  async mounted() {
    if (this.domain) {
      await this.initSummary();
        this.trafficInterval = setInterval(() => {
        this.initSummary();
      }, 10000);
      this.$store.commit("setMainTrafficInterval", this.trafficInterval);
    
    }
  },
  beforeUnmount() {
    if (this.trafficInterval) {
      clearInterval(this.trafficInterval);
      this.trafficInterval = null;
    }
  },
};
</script>
